import { IconProps } from '../iconProps';

export const CircleDashed = ({ size = 24, fill = '' }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill={fill}
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect
        x='1'
        y='1'
        width='22'
        height='22'
        rx='11'
        stroke='white'
        stroke-opacity='0.24'
        stroke-width='2'
        stroke-dasharray='4 4'
      />
    </svg>
  );
};
